@if (bucket(); as bucket) {
  <div class="bucket-component-wrapper">
    @if (!bucket.isSetup) {
      <div class="bucket-setup">
        <app-bucket-setup-toolbar [bucket]="bucket" />
        <div class="bucket-setup-graphic">
          <img src="assets/images/setupbudgets.svg" alt="lady setting up her budgets" />
        </div>
        <div class="bucket-setup-content">
          @if (bucket.type === 'BUDGET') {
            <p>Set your monthly budget amount.</p>
          }
          @if (bucket.type === 'INCOME') {
            <p>Set your expected monthly income amount.</p>
          }
          @if (bucket.type === 'SAVINGS') {
            <p>Set your monthly savings contribution.</p>
          }
          @if (bucket.type === 'TRANSFERS') {
            <p>Set the monthly amount for this transfer bucket.</p>
          }
          <button
            appUiButton
            appearance="ghost"
            tone="danger"
            class="bucket-setup-delete"
            type="button"
            (click)="deleteBucket()"
            [disabled]="deleting"
          >
            @if (!deleting) {
              Nevermind, delete this budget
            }
            @if (deleting) {
              Deleting...
            }
          </button>
        </div>
      </div>
    } @else {
      @let showTrends = bucket.type === 'BUDGET' && reportsEnabled();
      <!-- With Trends there are five tabs: tighter triggers and a short "Add" label keep them on one row in a phone-width drawer. -->
      <app-ui-tabs
        class="bucket-list-panel app-ui-tabs-fill @container flex h-full min-h-0 flex-1 basis-0 flex-col data-[compact-tabs]:[&_[role=tablist]]:!gap-0 data-[compact-tabs]:[&_[role=tab]]:!px-2.5"
        [attr.data-compact-tabs]="showTrends ? '' : null"
        [stretch]="true"
        [(activeTab)]="selectedTab"
      >
        <app-ui-tab tabId="transactions" label="Activity">
          <div class="bucket-list-panel-wrapper overflow-y-auto overscroll-contain">
            <app-bucket-transaction-list
              class="flex h-full min-h-0 flex-1 basis-0 flex-col"
              [bucket]="bucket"
              [loading]="transactionsLoading()"
              [showEmptyActions]="!isInDrawer()"
              (bucketUpdated)="update()"
            />
          </div>
        </app-ui-tab>
        @if (showTrends) {
          <app-ui-tab tabId="trends" label="Trends">
            <div class="bucket-list-panel-wrapper overflow-y-auto overscroll-contain">
              <app-bucket-trend [bucketId]="bucket.id" [monthYear]="bucket.monthYear" [active]="selectedTab === 'trends'" />
            </div>
          </app-ui-tab>
        }
        @if (!bucket.archivedMonth) {
          <app-ui-tab tabId="add" label="Add transaction">
            <!-- One span, so the trigger's flex gap can't open up between the words. -->
            <ng-template appUiTabLabel
              ><span>Add<span [class]="showTrends ? '@max-[439px]:sr-only' : ''"> transaction</span></span></ng-template
            >
            <div class="bucket-list-panel-wrapper overflow-y-auto overscroll-contain">
              <app-add-transaction [bucket]="bucket" (transactionAdded)="update()" />
            </div>
          </app-ui-tab>
        }
        @if (((month.isThisMonthCurrent$ | async) || canTransferInPastMonth()) && bucket.fund && !bucket.archivedMonth) {
          <app-ui-tab tabId="exchange" label="Transfer">
            <div class="bucket-list-panel-wrapper overflow-y-auto overscroll-contain">
              <app-transfer-budget [bucket]="bucket" (transferSuccess)="update($event)" />
            </div>
          </app-ui-tab>
        }
        <app-ui-tab tabId="edit" label="Settings">
          <div class="bucket-list-panel-wrapper overflow-y-auto overscroll-contain">
            <app-edit-bucket
              [bucket]="bucket"
              (bucketEdited)="update($event)"
              (bucketDeleted)="bucketDeleted()"
            />
          </div>
        </app-ui-tab>
      </app-ui-tabs>
    }
  </div>
}
